(() => {
  const track = (name, detail = {}) => {
    document.dispatchEvent(new CustomEvent(`dartsrx:${name}`, { detail }));

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: `dartsrx_${name}`, ...detail });
    }
  };

  const initReveals = (scope) => {
    const items = [...scope.querySelectorAll('[data-dartitis-reveal]:not([data-dartitis-reveal-ready])')];
    if (!items.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
    );

    items.forEach((item) => {
      item.setAttribute('data-dartitis-reveal-ready', '');
      observer.observe(item);
    });
  };

  const initDetails = (scope) => {
    scope.querySelectorAll('[data-dartitis-detail]:not([data-dartitis-tracked])').forEach((details, index) => {
      details.setAttribute('data-dartitis-tracked', '');
      details.addEventListener('toggle', () => {
        if (!details.open) return;

        const summary = details.querySelector('summary');
        track('dartitis_detail_open', {
          item: index + 1,
          label: summary ? summary.textContent.trim().slice(0, 80) : ''
        });
      });
    });

    scope.querySelectorAll('[data-dartitis-evidence]:not([data-dartitis-evidence-tracked])').forEach((details) => {
      details.setAttribute('data-dartitis-evidence-tracked', '');
      details.addEventListener('toggle', () => {
        if (details.open) track('dartitis_evidence_open');
      });
    });

    scope.querySelectorAll('[data-dartitis-faq]:not([data-dartitis-faq-tracked])').forEach((details, index) => {
      details.setAttribute('data-dartitis-faq-tracked', '');
      details.addEventListener('toggle', () => {
        if (details.open) track('dartitis_faq_open', { item: index + 1 });
      });
    });
  };

  const initInteractions = (scope) => {
    initDetails(scope);

    scope.querySelectorAll('a[href="#dartitis-buy"]:not([data-dartitis-cta-tracked])').forEach((link) => {
      link.setAttribute('data-dartitis-cta-tracked', '');
      link.addEventListener('click', () => track('dartitis_product_cta'));
    });
  };

  const initSmoothBuyScroll = () => {
    if (document.documentElement.hasAttribute('data-drx-buy-scroll-ready')) return;

    document.documentElement.setAttribute('data-drx-buy-scroll-ready', '');
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link) return;

      let destination;
      try {
        destination = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }

      if (
        destination.origin !== window.location.origin ||
        destination.pathname !== window.location.pathname ||
        !destination.hash ||
        destination.hash === '#'
      ) {
        return;
      }

      const target = document.querySelector(destination.hash);
      if (!target) return;

      event.preventDefault();
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
      });

      track('landing_anchor_cta', { target: destination.hash.slice(1) });
    });
  };

  const initProgress = () => {
    const progress = document.querySelector('[data-dartitis-progress]');
    const page = document.querySelector('[data-dartitis-page]');
    if (!progress || !page || progress.hasAttribute('data-dartitis-ready')) return;

    progress.setAttribute('data-dartitis-ready', '');
    let frame = 0;

    const update = () => {
      frame = 0;
      const scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      const value = Math.min(1, Math.max(0, window.scrollY / scrollable));
      progress.style.transform = `scaleX(${value})`;
    };

    const requestUpdate = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();
  };

  const initStickyBuy = () => {
    const sticky = document.querySelector('[data-dartitis-sticky-buy]');
    const product = document.querySelector('#dartitis-buy');
    const bridge = document.querySelector('#dartitis-flight-fuel');
    if (!sticky || !product || !bridge || sticky.hasAttribute('data-dartitis-ready')) return;

    sticky.setAttribute('data-dartitis-ready', '');
    let bridgeSeen = false;
    let productVisible = false;
    let productTracked = false;

    const sync = () => sticky.classList.toggle('is-visible', bridgeSeen && !productVisible);

    const bridgeObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          bridgeSeen = true;
          sync();
          bridgeObserver.disconnect();
        });
      },
      { threshold: 0.08 }
    );

    const productObserver = new IntersectionObserver(
      (entries) => {
        productVisible = entries.some((entry) => entry.isIntersecting);
        sync();
        if (productVisible && !productTracked) {
          productTracked = true;
          track('dartitis_product_view');
        }
      },
      { threshold: 0.08 }
    );

    bridgeObserver.observe(bridge);
    productObserver.observe(product);
  };

  const init = (scope = document) => {
    initSmoothBuyScroll();
    if (!document.querySelector('[data-dartitis-page]')) return;

    initReveals(scope);
    initInteractions(scope);
    initProgress();
    initStickyBuy();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
